var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19957_74178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 6.49H16.2402V3.19C16.2402 2.54 15.7002 2 15.0302 2H8.96023C8.30023 2 7.75023 2.54 7.75023 3.19V6.49H6.50023C5.67023 6.49 4.99023 7.15 4.99023 7.97V19C4.99023 19.82 5.66023 20.49 6.50023 20.49H6.85023V21.39C6.85023 21.73 7.13023 22 7.48023 22C7.83023 22 8.11023 21.73 8.11023 21.39V20.49H15.7302V21.39C15.7302 21.73 16.0102 22 16.3602 22C16.7102 22 16.9902 21.73 16.9902 21.39V20.49H17.4802C18.3202 20.49 18.9902 19.82 18.9902 19V7.97C18.9902 7.15 18.3202 6.49 17.4902 6.49H17.5002ZM9.03023 17.36C9.03023 17.71 8.75023 17.99 8.39023 17.99C8.03023 17.99 7.75023 17.71 7.75023 17.36V9.62C7.75023 9.27 8.04023 8.99 8.39023 8.99C8.74023 8.99 9.03023 9.27 9.03023 9.62V17.36ZM12.6402 17.36C12.6402 17.71 12.3602 17.99 12.0002 17.99C11.6402 17.99 11.3602 17.71 11.3602 17.36V9.62C11.3602 9.27 11.6402 8.99 12.0002 8.99C12.3602 8.99 12.6402 9.27 12.6402 9.62V17.36ZM12.9402 6.49H9.28023V3.98C9.28023 3.72 9.50023 3.5 9.77023 3.5H14.2502C14.5102 3.5 14.7302 3.72 14.7302 3.98V6.49H12.9502H12.9402ZM16.2402 17.36C16.2402 17.71 15.9602 17.99 15.6002 17.99C15.2402 17.99 14.9602 17.71 14.9602 17.36V9.62C14.9602 9.27 15.2502 8.99 15.6002 8.99C15.9502 8.99 16.2402 9.27 16.2402 9.62V17.36Z",
    fill: "#2A313C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19957_74178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 20,
    fill: "white",
    transform: "translate(5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.92f7e56454528823d04420b41b5eca50.svg";
export { ForwardRef as ReactComponent };